export default __webpack_public_path__ + "static/mvp-hero-fallback-mobile-41e4e5788ffafca10739d27ba0a2a814.jpg";